import { instance } from './axiosClient';
export const API = instance;
